import { React, PropTypes } from 'imports';
import { toArray } from 'utils';
import Enum from 'utils/Enum';
import './RadioGroup.less';

export const Layout = Enum('VERTICAL', 'HORIZONTAL');

export const Appearance = Enum('RADIO', 'BUTTON');

export const valuePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

export class Option extends React.PureComponent {
    static get displayName() {
        return "RadioGroup.Option";
    }

    static get propTypes() {
        return {
            value: valuePropType,
            className: PropTypes.string,
            disabled: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            className: ''
        };
    }

    render() {
        return null;
    }
}

export default class RadioGroup extends React.PureComponent {
    static get Layout() {
        return Layout;
    }

    static get Appearance() {
        return Appearance;
    }

    static get valuePropType() {
        return valuePropType;
    }

    static get Option() {
        return Option;
    }

    static get propTypes() {
        return {
            value: valuePropType,
            clearable: PropTypes.bool, // click on already selected radio/button removes all selection
            layout: PropTypes.oneOf([Layout.HORIZONTAL, Layout.VERTICAL]),
            appearance: PropTypes.oneOf(Object.values(Appearance)),
            className: PropTypes.string,
            disabled: PropTypes.bool,
            onChange: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            value: null,
            clearable: false,
            layout: Layout.VERTICAL,
            appearance: Appearance.RADIO,
            className: '',
            disabled: false
        }
    }

    _id = `radio-group${(Math.random() * Number.MAX_SAFE_INTEGER) | 0}`

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (DEBUG && toArray(nextProps.children || []).flatten().some(child => child && child.type !== Option)) {
            throw new Error('Children of RadioGroup must be instances of RadioGroup.Option');
        }
    }

    _onChange = (value, event) => {
        if ((this.props.appearance === Appearance.BUTTON || event.target.checked) && (value !== this.props.value || this.props.clearable) && this.props.onChange) {
            this.props.onChange(this, value !== this.props.value || !this.props.clearable ? value : null);
        }
    }

    _onInputClick = (event) => {
        // it seems that internally <label for="..." /> is not handled as a part of component, but after being clicked it fully simulates another click on connected input
        // they happen in separate threads and there's no way to check if the event's are connected
        // it breaks some parent components's logic which handle own clicks, e. g. if checking an option opens a Popup, the second simulated click closes one immediately
        // other components should not really know about this one's structure and it's enough to propagate only one click from the root of the component, any of two event qualifies
        // let's always propagate the one that happened earlier
        if (this._labelClickEvent) {
            event.stopPropagation();
            this._labelClickEvent.preventDefault();
        }
    }

    _onLabelClick = (event) => {
        this._labelClickEvent = event.nativeEvent;

        let originalPreventDefault = this._labelClickEvent.preventDefault;
        this._labelClickEvent.preventDefault = () => {
            this._labelClickEvent.preventDefault = originalPreventDefault;
            this._labelClickEvent = null;
        }
    }

    _layoutClass() {
        const layout = this.props.layout;
        // switch (layout) {
        //     case Layout.VERTICAL: return 'vertical';
        //     ...
        // }
        if (DEBUG) {
            // TODO fix when redux-logger supports Symbols as action types
            if (typeof layout !== 'string') {
                throw new Error(`Incorrect enum value type: ${layout}`);
            }
        }
        return layout.toLowerCase();
    }

    _keyify(child, index) {
        return Array.isArray(child) ? child.map((subchild, subindex) => this._keyify(subchild, index + '.' + subindex)) :
            {
                key: child && child.key ? 'external-' + child.key : 'index-' + index.toString(),
                child
            };
    }

    render() {
        return (
            <div className={`radio-group ${this._layoutClass()} ${this.props.clearable ? 'clearable' : ''} ${this.props.className}`}>
                {
                    toArray(this.props.children || [])
                        .map((child, index) => this._keyify(child, index))
                        .flatten()
                        .filter(({ child }) => child)
                        .map(({ child, key }) => {
                            const isChecked = this.props.value === child.props.value;

                            return (
                                this.props.appearance === Appearance.RADIO ?
                                    <div key={key} className={'radio ' + child.props.className}>
                                        <input
                                            type="radio" id={this._id + key} name={this._id}
                                            disabled={this.props.disabled || child.props.disabled}
                                            value={child.props.value}
                                            checked={isChecked}
                                            onChange={this._onChange.bind(this, child.props.value)}
                                            onClick={this._onInputClick} />
                                        <label htmlFor={this._id + key} onClick={this._onLabelClick} >{child.props.children}</label>
                                    </div> :
                                    <div key={key} className={'radio ' + (isChecked ? 'active ' : '') + child.props.className}>
                                        <button className={isChecked ? 'primary' : 'secondary'}
                                            disabled={this.props.disabled || child.props.disabled}
                                            onClick={this._onChange.bind(this, child.props.value)}>
                                            {child.props.children}
                                        </button>
                                    </div>
                            );
                        })}
            </div>
        );
    }
}
